var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('carousel',{attrs:{"perPage":1,"autoplay":true,"loop":true,"adjustableHeight":true,"navigationEnabled":false}},_vm._l((_vm.rows),function(item,index){return _c('slide',{key:index},[_c('a',{attrs:{"href":item.link}},[_c('img',{staticStyle:{"width":"100%","height":"200px"},attrs:{"src":item.image,"alt":"Carousel Item"}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }